import { defineStore } from 'pinia'

export const useIdleStore = defineStore('idle', {
  state: () => ({
    show: false,
    secondsLeft: 30,
  }),
  actions: {
    open(seconds = 30) {
      this.secondsLeft = seconds
      this.show = true
    },
    close() {
      this.show = false
    },
    tick() {
      if (this.secondsLeft > 0) this.secondsLeft--
    }
  },
  persist: false
})
